/**
 * @generated SignedSource<<a364022fadadec5aeee23161eec668de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RouteConfig_PortalProfileComplete_Query$variables = {
  characteristicId: string;
};
export type RouteConfig_PortalProfileComplete_Query$data = {
  readonly viewer: {
    readonly characteristic: {
      readonly " $fragmentSpreads": FragmentRefs<"PortalProfileComplete_characteristic">;
    };
    readonly user: {
      readonly panelist: {
        readonly " $fragmentSpreads": FragmentRefs<"PortalProfileComplete_panelist">;
      } | null;
    } | null;
  };
};
export type RouteConfig_PortalProfileComplete_Query = {
  response: RouteConfig_PortalProfileComplete_Query$data;
  variables: RouteConfig_PortalProfileComplete_Query$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "characteristicId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "characteristicId",
    "variableName": "characteristicId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "userSpecified",
  "storageKey": null
},
v5 = [
  (v2/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RouteConfig_PortalProfileComplete_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CharacteristicNode",
            "kind": "LinkedField",
            "name": "characteristic",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "PortalProfileComplete_characteristic"
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PanelistNode",
                "kind": "LinkedField",
                "name": "panelist",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "PortalProfileComplete_panelist"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RouteConfig_PortalProfileComplete_Query",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v1/*: any*/),
            "concreteType": "CharacteristicNode",
            "kind": "LinkedField",
            "name": "characteristic",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "CharacteristicResponseNodeConnection",
                "kind": "LinkedField",
                "name": "responses",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CharacteristicResponseNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CharacteristicResponseNode",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicAnswerNode",
                            "kind": "LinkedField",
                            "name": "answer",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              (v4/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "customAnswer",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PanelistNode",
                            "kind": "LinkedField",
                            "name": "panelist",
                            "plural": false,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          },
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "textValue",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "CharacteristicRowNode",
                            "kind": "LinkedField",
                            "name": "row",
                            "plural": false,
                            "selections": (v5/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CharacteristicElementMetaNode",
                "kind": "LinkedField",
                "name": "elementMeta",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "responseValidation",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "target",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "target2",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CharacteristicAnswerNode",
                "kind": "LinkedField",
                "name": "answers",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "CharacteristicRowNode",
                "kind": "LinkedField",
                "name": "rows",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "UserNode",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "PanelistNode",
                "kind": "LinkedField",
                "name": "panelist",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CustomPortalNode",
                    "kind": "LinkedField",
                    "name": "customPanelistPortal",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "contactEmail",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "customColor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fadeBgBottom",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "faviconUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "footerImageUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerMarkup",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "headerMarkupEnabled",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "heroAssetUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "heroBackgroundUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hidePanelistProfile",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "pageTitle",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "privacyPolicyUrl",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "termsLabel",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "termsUrl",
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "569befe2de1f2964604baf19eef97195",
    "id": null,
    "metadata": {},
    "name": "RouteConfig_PortalProfileComplete_Query",
    "operationKind": "query",
    "text": "query RouteConfig_PortalProfileComplete_Query(\n  $characteristicId: String!\n) {\n  viewer {\n    characteristic(characteristicId: $characteristicId) {\n      ...PortalProfileComplete_characteristic\n      id\n    }\n    user {\n      panelist {\n        ...PortalProfileComplete_panelist\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment FormItemCharacteristicResponses_characteristic on CharacteristicNode {\n  id\n  elementMeta {\n    responseValidation\n    target\n    target2\n  }\n  text\n  type\n  ...InputCharacteristicResponses_characteristic\n}\n\nfragment FormItemCharacteristicResponses_characteristicResponses on CharacteristicResponseNode {\n  ...InputCharacteristicResponses_characteristicResponses\n  answer {\n    id\n  }\n  customAnswer\n}\n\nfragment InputCharacteristicResponseDate_characteristic on CharacteristicNode {\n  id\n}\n\nfragment InputCharacteristicResponseDate_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseGridSingleSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n  }\n  rows {\n    id\n    text\n  }\n}\n\nfragment InputCharacteristicResponseGridSingleSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  answer {\n    id\n  }\n  row {\n    id\n  }\n}\n\nfragment InputCharacteristicResponseMultiSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseMultiSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  customAnswer\n  answer {\n    id\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseNumber_characteristic on CharacteristicNode {\n  id\n  elementMeta {\n    responseValidation\n    target\n    target2\n  }\n}\n\nfragment InputCharacteristicResponseNumber_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseOpenEnd_characteristic on CharacteristicNode {\n  id\n}\n\nfragment InputCharacteristicResponseOpenEnd_characteristicResponses on CharacteristicResponseNode {\n  id\n  textValue\n}\n\nfragment InputCharacteristicResponseSingleSelect_characteristic on CharacteristicNode {\n  id\n  answers {\n    id\n    text\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponseSingleSelect_characteristicResponses on CharacteristicResponseNode {\n  id\n  customAnswer\n  answer {\n    id\n    userSpecified\n  }\n}\n\nfragment InputCharacteristicResponses_characteristic on CharacteristicNode {\n  type\n  ...InputCharacteristicResponseDate_characteristic\n  ...InputCharacteristicResponseGridSingleSelect_characteristic\n  ...InputCharacteristicResponseMultiSelect_characteristic\n  ...InputCharacteristicResponseNumber_characteristic\n  ...InputCharacteristicResponseOpenEnd_characteristic\n  ...InputCharacteristicResponseSingleSelect_characteristic\n}\n\nfragment InputCharacteristicResponses_characteristicResponses on CharacteristicResponseNode {\n  ...InputCharacteristicResponseDate_characteristicResponses\n  ...InputCharacteristicResponseGridSingleSelect_characteristicResponses\n  ...InputCharacteristicResponseMultiSelect_characteristicResponses\n  ...InputCharacteristicResponseNumber_characteristicResponses\n  ...InputCharacteristicResponseOpenEnd_characteristicResponses\n  ...InputCharacteristicResponseSingleSelect_characteristicResponses\n}\n\nfragment PortalProfileComplete_characteristic on CharacteristicNode {\n  id\n  type\n  text\n  responses {\n    edges {\n      node {\n        answer {\n          id\n          userSpecified\n        }\n        customAnswer\n        panelist {\n          id\n        }\n        ...FormItemCharacteristicResponses_characteristicResponses\n        id\n      }\n    }\n  }\n  ...FormItemCharacteristicResponses_characteristic\n}\n\nfragment PortalProfileComplete_panelist on PanelistNode {\n  customPanelistPortal {\n    contactEmail\n    customColor\n    fadeBgBottom\n    faviconUrl\n    footerImageUrl\n    headerMarkup\n    headerMarkupEnabled\n    heroAssetUrl\n    heroBackgroundUrl\n    hidePanelistProfile\n    pageTitle\n    privacyPolicyUrl\n    termsLabel\n    termsUrl\n    id\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "b57c38a7cb76584df675d9c01bab792b";

export default node;
